import TextBox from 'devextreme-react/text-box'
import { Validator } from 'devextreme-react'
import { RequiredRule } from 'devextreme-react/cjs/validator'
import { t } from 'i18next'

interface TextInputProps {
    className?: string
    label?: string
    required?: boolean
    disabled?: boolean
    readonly?: boolean
    value: string
    onChange: (value: string) => void
}

export default function TextInput(props: TextInputProps) {
    return (
        <TextBox
            className={props.className}
            label={`${props.label || ''} ${props.required ? '*' : ''}`}
            disabled={props.disabled}
            readOnly={props.readonly}
            focusStateEnabled={!props.disabled && !props.readonly}
            hoverStateEnabled={!props.disabled && !props.readonly}
            stylingMode="outlined"
            value={props.value}
            onValueChanged={(e) => props.onChange(e.value)}>
            { props.required && <Validator>
                <RequiredRule message={t("This field is required")} />
            </Validator> }
        </TextBox>
    )
}
